import React from "react";
import { Card, CardContent, CardHeader } from "./ui/card";
import { Button } from "./ui/button";
import { X, Calendar, Bell } from "lucide-react";

interface ComingSoonModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

const ComingSoonModal: React.FC<ComingSoonModalProps> = ({
  isOpen,
  onClose,
  title = "Feature",
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      <Card className="w-full max-w-md mx-4 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
          aria-label="Close modal"
        >
          <X className="h-5 w-5" />
        </button>

        <CardHeader className="text-center pb-6">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-blue-50 rounded-full">
              <Calendar className="h-8 w-8 text-blue-600" />
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            {title} Coming Soon!
          </h2>
          <p className="text-gray-600">
            We're working hard to bring you this feature. Stay tuned for
            updates!
          </p>
        </CardHeader>

        <CardContent className="space-y-6">
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center gap-3 mb-3">
              <Bell className="h-5 w-5 text-blue-600" />
              <h3 className="font-semibold text-gray-900">Get Notified</h3>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              Want to be the first to know when {title.toLowerCase()} is
              available? Drop us a line and we'll keep you updated!
            </p>
            <Button
              onClick={() => {
                window.location.href = `mailto:team@essaypilot.io?subject=Notify me about ${title}&body=Hi! I'm interested in the ${title.toLowerCase()} feature. Please notify me when it's available.`;
              }}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white"
            >
              Notify Me
            </Button>
          </div>

          <div className="flex gap-3">
            <Button onClick={onClose} variant="outline" className="flex-1">
              Close
            </Button>
            <Button
              onClick={() => {
                const contactButton = document.querySelector(
                  "[data-contact-button]"
                );
                if (contactButton) {
                  (contactButton as HTMLButtonElement).click();
                  onClose();
                } else {
                  window.location.href =
                    "mailto:team@essaypilot.io?subject=Feature Request";
                }
              }}
              className="flex-1 bg-black hover:bg-gray-800 text-white"
            >
              Contact Us
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ComingSoonModal;
